import React, { useEffect } from 'react';
import { useTable, usePagination, useSortBy, useExpanded, useGlobalFilter, useFilters } from 'react-table';
import { Table, Dropdown, Icon } from 'semantic-ui-react';

import GlobalFilter from './GlobalFilter';
import './../packs/index.scss';

const ReactTable = ({ columns, data, renderRowSubComponent, dateFilterValue, selectedFuneralHomes }) => {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    setFilter
  } = useTable(
    {
      columns,
      data,
      globalFilter: (rows, columnIds, globalFilterValue) => {
        return rows.filter((row) => {
          const event = row.original;
          const filterValue = globalFilterValue.toLowerCase();
          return (
            event.firstName.toLowerCase().includes(filterValue) ||
            event.lastName.toLowerCase().includes(filterValue) ||
            `${event.firstName.toLowerCase()} ${event.lastName.toLowerCase()}`.includes(filterValue) ||
            event.clientEmails && event.clientEmails.emails && event.clientEmails.emails.some((email) => {
              return email.toLowerCase().includes(filterValue);
            })
          );
        });
      },
      initialState: { pageIndex: 0, hiddenColumns: ["funeralHomeId"] },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
  )

  useEffect(() => {
    // This will now use our custom filter for age
    setFilter("streams", dateFilterValue);
  }, [dateFilterValue]);

  useEffect(() => {
    setFilter("funeralHomeId", selectedFuneralHomes);
    selectedFuneralHomes
  }, [selectedFuneralHomes]);

  // Render the UI for your table
  return (
    <>
      <GlobalFilter
        // preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
      />
      <Table className="table" structured {...getTableProps()}>
        <Table.Header>
          {headerGroups.map(headerGroup => (
            <Table.Row {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <Table.HeaderCell width={2} className="headerCell" {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? <Icon name="caret down"/>
                        : <Icon name="caret up"/>
                      : ''}
                  </span>
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
        </Table.Header>
        <Table.Body {...getTableBodyProps()}>
          {
            page.length === 0 && (state.filters.length > 0 || state.globalFilter) && 
            <Table.Row>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ padding: "50px 0 50px 0", fontStyle: "italic" }}>Try adjusting your filters.</Table.Cell>
            </Table.Row>
          }
          {page.map((row, i) => {
            prepareRow(row);
            const rowProps = row.getRowProps();
            return (
              <React.Fragment key={rowProps.key}>
                <Table.Row {...rowProps}>
                  {row.cells.map((cell) => {
                    return <Table.Cell {...cell.getCellProps()}>{cell.render('Cell')}</Table.Cell>
                  })}
                </Table.Row>
                {row.isExpanded
                  && renderRowSubComponent({ row, rowProps })}
              </React.Fragment>
            )
          })}
        </Table.Body>
      </Table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <div className="pageDropdown">
          Rows per page:
          <Dropdown value={state.pageSize} options={[
            { key: 1, text: '10', value: 10 },
            { key: 2, text: '20', value: 20 },
            { key: 3, text: '30', value: 30 },
            { key: 4, text: '40', value: 40 },
            { key: 5, text: '50', value: 50 }]} 
            onChange={(e, data) => {
              setPageSize(Number(data.value))
            }}
          />
        </div>
        <div className="pageMover">
          <Icon name='arrow left' onClick={() => previousPage()} disabled={!canPreviousPage} />{' '}
          <span>
            Page{' '}
            <strong>
              {state.pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span>{' '}
          <Icon name='arrow right' onClick={() => nextPage()} disabled={!canNextPage} />
        </div>
      </div>
    </>
  )
}

export default ReactTable;
